import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contact" className="relative bg-ink-2 border-t border-white/10 pt-20 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 pb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.png" alt="Dashmesh Enterprises logo" className="w-9 h-9 object-contain" />
              <div className="leading-none">
                <div className="font-head font-extrabold tracking-widest text-xl text-white">DASHMESH</div>
                <div className="font-mono text-[9px] tracking-[0.35em] text-signal">ENTERPRISES</div>
              </div>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-sm mb-6">
              Motion, machined to the arcsecond. Authorized sourcing partner for precision robotics
              components across India.
            </p>
            <div className="flex flex-wrap gap-2">
              {["Cubemars", "Laifual", "Leaderdrive", "Homwing", "Bonsystems"].map((b) => (
                <span key={b} className="font-mono text-[10px] uppercase tracking-wider border border-white/10 px-2 py-1 text-slate-400">{b}</span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4 lg:col-start-7">
            <div className="font-mono text-[11px] uppercase tracking-widest text-signal mb-6">Contact</div>
            <ul className="space-y-4 text-slate-300">
              <li className="flex gap-3"><MapPin className="w-5 h-5 text-signal shrink-0 mt-0.5" />
                <span>106/13-B, G.I.D.C. Makarpura, nr. Vadsar Bridge, Vadodara, Gujarat — 390010, India</span></li>
              <li className="flex gap-3"><Phone className="w-5 h-5 text-signal shrink-0" />
                <a href="tel:+918866671327" className="hover:text-signal transition-colors" data-testid="footer-phone">+91-8866671327</a></li>
              <li className="flex gap-3"><Mail className="w-5 h-5 text-signal shrink-0" />
                <a href="mailto:info@dashmeshtech.com" className="hover:text-signal transition-colors" data-testid="footer-email">info@dashmeshtech.com</a></li>
              <li className="flex gap-3"><Linkedin className="w-5 h-5 text-signal shrink-0" />
                <a href="https://linkedin.com/in/butindersingh-matharu-5250801b" target="_blank" rel="noopener noreferrer" className="hover:text-signal transition-colors" data-testid="footer-linkedin">Butinder Singh Matharu</a></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-widest text-signal mb-6">Proprietor</div>
            <div className="text-white font-head font-bold uppercase text-lg leading-tight">BUTINDERSINGH<br />Matharu</div>
            <div className="font-mono text-[11px] text-slate-500 mt-2">Owner · Engineer</div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="font-mono text-[11px] text-slate-500">© {new Date().getFullYear()} Dashmesh Enterprises. All rights reserved.</div>
          <Link to="/admin" className="font-mono text-[11px] text-slate-600 hover:text-signal transition-colors" data-testid="footer-admin-link">Admin Portal</Link>
        </div>
      </div>
    </footer>
  );
}
